import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

export type Payload = {
  token?: string;
  backup_code?: string;
};

export const disable2fa = async (payload: Payload): Promise<void> => {
  await Axios.post<void>(
    POST_URL(payload.token, payload.backup_code).disable2fa
  );
};

export function useDisable2fa() {
  return useMutation<void, AxiosError<BaseError>, Payload>((payload: Payload) =>
    disable2fa(payload)
  );
}
